// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"MagazineStageBoxArticle-module-sub-title","title":"MagazineStageBoxArticle-module-title","socialMediaList":"MagazineStageBoxArticle-module-social-media-list"};